export const CHECK_EXPORT_NOTIFICATIONS = "/exportnotification/v2/:userId"

export const CHECK_COUNT_CREATED = "/exportnotification/count/countCreated"

export const DOWNLOAD_FILE = "/exportnotification/download/:filename"

export const DOWNLOAD_FILE_S3 = "/exportnotification/generate-presigned-url/:id"

export const GET_TEMPLATES = "/export-templates/"

export const GET_ALL_TEMPLATES = "/export-templates/all"

export const GET_TEMPLATE_BY_ID = "/export-templates/:id"

export const GET_TEMPLATES_BY_ROLEID = "/export-templates/role/:id"

export const POST_TEMPLATE = "/export-templates/"

export const UPDATE_TEMPLATE = "/export-templates/:id"

export const RESTORE_TEMPLATE = "/export-templates/:id/restore"

export const DELETE_TEMPLATE = "/export-templates/:id"

export const FORCE_DELETE_TEMPLATE = "/export-templates/:id/force"
